import {useQueries} from "@tanstack/react-query";
import {Product, ProductService} from "../services/product-service";

export const SIGNUP_PRODUCT_TYPES = ['monthly', 'yearly'] as const;
export type SignupProductType = typeof SIGNUP_PRODUCT_TYPES[number];

export const useSignupProducts = () => {
    const results = useQueries({
        queries: SIGNUP_PRODUCT_TYPES.map(productType => ({
            queryKey: ['products', 'type', productType],
            queryFn: async () => await ProductService.getByType(productType),
            retry: false,
        })),
    });

    const products = results
        .map(result => result.data)
        .filter((product): product is Product => !!product && product.isActive);

    return {
        products,
        isPending: results.some(result => result.isPending),
        isError: products.length === 0 && results.every(result => !result.isPending),
    };
};
